// extracted by mini-css-extract-plugin
export default {"resizeP":"ChiSonoMe_resizeP__i6tor","resizeImg":"ChiSonoMe_resizeImg__zgqXz","changeA":"ChiSonoMe_changeA__lE2Nk"};